import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAhuzBdbJ1etq0eA9db_wCJqOskWjRswEQ",
  authDomain: "whatblue-50b8f.firebaseapp.com",
  databaseURL: "https://whatblue-50b8f-default-rtdb.firebaseio.com",
  projectId: "whatblue-50b8f",
  storageBucket: "whatblue-50b8f.firebasestorage.app",
  messagingSenderId: "960347283687",
  appId: "1:960347283687:web:1c074412624217bee70242",
  measurementId: "G-T8BRBEYF1G"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);